<template>
  <component
    :is="rowHeader ? 'th' : 'td'"
    class="sb-data-table__body-cell"
    :class="computedClasses"
    :width="width"
    :scope="rowHeader ? 'row' : undefined"
    :data-testid="$attrs['data-testid']"
  >
    <span v-if="showLabel" class="sb-data-table__body-cell-label"
      >{{ label }}:</span
    >
    <slot :row="row" />
  </component>
</template>

<script lang="ts">
export default {
  name: 'SbDataTableColumn',
  props: {
    label: {
      type: String,
      default: null,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    sortable: {
      type: Boolean,
    },
    modelValue: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: null,
    },
    isContentCentered: {
      type: Boolean,
      default: false,
    },
    isSortIconAlwaysVisible: {
      type: Boolean,
      default: false,
    },
    hideMobileLabel: {
      type: Boolean,
      default: false,
    },
    hideMobile: {
      type: Boolean,
      default: false,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: undefined,
    },
    rowHeader: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedClasses() {
      return {
        'sb-data-table__body-cell--centered': this.isContentCentered,
        'sb-data-table__body-cell--mobile-hidden': this.hideMobile,
        'sb-data-table__body-cell--no-padding': this.noPadding,
        'sb-data-table__col-main': this.rowHeader,
      }
    },
    showLabel() {
      return this.label && !this.hideMobileLabel
    },
  },
}
</script>
